import { combinePath } from '@ms/yammer-web-support/dist/location';
import type { FC, NamedExoticComponent } from 'react';
import React, { memo } from 'react';
import { useRouteMatch } from 'react-router-dom';

import type { RouteComponentPreloaderProps, SubrouteComponentPreloaderProps } from './SubrouteComponentPreloader.types';

const RouteComponentPreloader: FC<RouteComponentPreloaderProps> = ({ route }) => {
  const match = useRouteMatch({
    path: route.path,
    exact: route.exact,
  });

  if (match) {
    void route.loader();
  }

  return null;
};

const SubrouteComponentPreloaderBase: FC<SubrouteComponentPreloaderProps> = ({ parentRoute }) => (
  <>
    {parentRoute.childRoutes.map((route) => (
      <RouteComponentPreloader key={route.path} route={{ ...route, path: combinePath(parentRoute.path, route.path) }} />
    ))}
  </>
);

const SubrouteComponentPreloader: NamedExoticComponent<SubrouteComponentPreloaderProps> =
  memo(SubrouteComponentPreloaderBase);
export default SubrouteComponentPreloader;
